import * as React from 'react';
import { Button, styled, Tooltip, tooltipClasses } from '@mui/material';
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Info } from 'react-feather'

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

export const TooltipApprovalInfo = (props) => {

    const {
        usuario_approval, 
        fecha_approval,
        texto_approval
    } = props

    return (
        <>
            <HtmlTooltip
                title={
                    <>
                        <b>Usuario Aprobación:</b> {usuario_approval}
                        <br></br>
                        <b>Fecha Aprobación:</b> {fecha_approval}
                    </>
                }
            >
                <Button style={{ color: '#6c757d' }}>
                    <Info /> {texto_approval}
                </Button>
            </HtmlTooltip>
        </>
    )
}
